import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { resyncPushPermissionState } from '@/lib/notifications/pushNotifications';

/**
 * Closes the gap where a user toggles notification permission in the OS Settings app
 * directly (not through our in-app UI) — without this, nothing re-checks OS permission
 * against our app-level consent flag until the user happens to revisit the notification
 * settings screen. Runs on cold start and every app resume from background.
 */
export function useSfmcPushPermissionSync() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    resyncPushPermissionState();

    const listenerPromise = App.addListener('resume', () => {
      resyncPushPermissionState();
    });

    return () => {
      listenerPromise.then(listener => listener.remove());
    };
  }, []);
}
